/**
 * Report an error to Datadog RUM without statically importing the SDK. The
 * import is lazy so the ~65 KB gz RUM bundle stays out of every page's
 * critical path, and the call no-ops unless instrumentation-client.ts actually
 * initialized RUM (dev / sampling 0 both skip init). Never throws — a failed
 * import or addError must not take down the error boundary that called it.
 */
export function reportRumError(error: Error, context?: object): void {
  void import('@datadog/browser-rum')
    .then(({ datadogRum }) => {
      if (datadogRum.getInitConfiguration()) {
        datadogRum.addError(error, context)
      }
    })
    .catch(() => {})
}
